<template>
  <div>
    <b-modal
      id="modal-tratamientoEnCurso"
      size='lg'
      body-class="pt-0"
      hide-footer
      header-class="p-0"
    >
    <template #modal-header="{ close }">
      <div class="w-100 modal-header-internacion py-2 px-3 d-flex
        justify-content-between align-items-center text-center">
        <h5 class="mb-0">Internacion en Curso</h5>
        <button
          type="button"
          class="close"
          @click="close()"
        >&times;</button>
      </div>
    </template>
      <div class="row">
        <div class="col-sm-12 px-0">
          <b-table responsive class="table table-sm"
            :fields="fieldsTabla"
            :items="listaTratamientos"
          >
            <template #cell(total)="data">
              {{data.item.total | numeral('0,0.00')}}
            </template>
            <template #cell(anticipo)="data">
              {{data.item.anticipo | numeral('0,0.00')}}
            </template>
            <template #cell(saldo)="data">
              {{data.item.saldo | numeral('0,0.00')}}
            </template>
            <template #cell(estado)="data">
              <span :class="getEstadoClass(data.item.estado)" class="font-weight-bold">
                {{ data.item.estado }}
              </span>
            </template>
            <template #cell(accion)="items">
              <div class="text-center">
                <input :id="'checkModal'+items.index"
                  v-model="items.item.checkInput"
                  @input="resetCheckInput(items.item)"
                  class="form-check-input position-static"
                  :disabled="items.item.estado==='Abierto' || items.item.estado === 'Pre Liquidacion'"
                  type="checkbox"
                >
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 text-right">
          <button class="btn btn-outline-dark mr-2" @click="cancelarModal()">
            Cancelar
          </button>
          <button class="btn btn-success" @click="confirmarModal()">
            Confirmar
          </button>
        </div>
      </div>
    </b-modal>
    <ModalCierreTratamiento />
    <TheModalDetalleTratamiento />
  </div>
</template>

<script>
import { util } from '@/plugins/util';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ModalCierreTratamiento from './TheModalCierreTratamiento.vue';
import TheModalDetalleTratamiento from './TheModalDetalleTratamiento.vue';

export default {
  name: 'ModalTratamientoEnCurso',
  components: {
    ModalCierreTratamiento,
    TheModalDetalleTratamiento,
  },
  data() {
    return {
      fieldsTabla: [
        {
          key: 'numero', label: 'Nº Int.', thClass: 'th-custom-color-gray', thStyle: { width: '10%' },
        },
        {
          key: 'fecha_registro', label: 'F/Registro', thClass: 'th-custom-color-gray', thStyle: { width: '13%' },
        },
        {
          key: 'fecha_cierre', label: 'F/Cierre', thClass: 'th-custom-color-gray', thStyle: { width: '13%' },
        },
        {
          key: 'total', label: 'Importe', thClass: 'th-custom-color-gray', thStyle: { width: '12%' },
        },
        {
          key: 'anticipo', label: 'Anticipo', thClass: 'th-custom-color-gray', thStyle: { width: '12%' },
        },
        {
          key: 'saldo', label: 'Saldo', thClass: 'th-custom-color-gray', thStyle: { width: '12%' },
        },
        {
          key: 'estado', label: 'Estado', thClass: 'th-custom-color-gray', thStyle: { width: '13%' },
        },
        {
          key: 'accion', label: '', thClass: 'th-custom-color-gray', thStyle: { width: '5%' },
        },
      ],
    };
  },
  methods: {
    getEstadoClass(estado) {
      if (estado === 'Abierto') return 'text-success';
      if (estado === 'Pre Liquidacion') return 'text-warning';
      if (estado === 'Liquidacion') return 'text-danger';
      if (estado === 'Cerrado') return 'text-danger';
      return '';
    },
    resetCheckInput(item) {
      this.listaTratamientos.forEach((el, index) => {
        if (el.id !== item.id) {
          this.listaTratamientos[index].checkInput = false;
        }
      });
    },
    cancelarModal() {
      this.resetChecks();
      this.$bvModal.hide('modal-tratamientoEnCurso');
    },
    async confirmarModal() {
      const RES = this.listaTratamientos.find((item) => item.checkInput === true) ?? null;
      if (RES === null) {
        util.showNotify('Seleccione un registro', 'warn');
        return;
      }
      const estado = this.getEstadoItemChecked;
      const esPreLiquidacionOLiquidacion = estado === 'Pre Liquidacion' || estado === 'Liquidacion';
      this.$bvModal.hide('modal-tratamientoEnCurso');
      if (esPreLiquidacionOLiquidacion && this.getHasVentaInternacionXServicio) {
        this.setPendingDescuento({
          gral: RES.descuento_gral ?? 0,
          monto: RES.descuento_monto ?? null,
        });
        if (estado === 'Pre Liquidacion') {
          await this.fetchServiciosComplementarios(RES.precierre_id);
        } else {
          await this.fetchServiciosLiquidacion(RES.id);
        }
        this.$bvModal.show('modal-tratamiento');
      } else {
        this.$bvModal.show('modal-cierreTratamiento');
      }
    },
    ...mapMutations('modalTratamiento', [
      'setPendingDescuento',
    ]),
    ...mapActions('modalTratamientoEnCurso', [
      'resetChecks',
    ]),
    ...mapActions('modalTratamiento', [
      'fetchServiciosComplementarios',
      'fetchServiciosLiquidacion',
    ]),
  },
  computed: {
    ...mapFields('modalTratamientoEnCurso', [
      'listaTratamientos',
    ]),
    ...mapGetters('modalTratamientoEnCurso', [
      'getEstadoItemChecked',
    ]),
    ...mapGetters('facturacion', [
      'getHasVentaInternacionXServicio',
    ]),
  },
};
</script>

<style scoped>
.modal-header-internacion {
  background: rgb(186, 233, 255);
  color: #fff;
}
.modal-header-internacion .modal-title {
  color: #fff;
  font-weight: 600;
}
.modal-header-internacion .close {
  color: #fff;
  opacity: 0.8;
}
::v-deep .th-custom-color-gray {
  background: rgb(223, 223, 223);
}
</style>
